import { render, staticRenderFns } from "./notaAutomatica.vue?vue&type=template&id=1d72b004"
import script from "./notaAutomatica.vue?vue&type=script&lang=js"
export * from "./notaAutomatica.vue?vue&type=script&lang=js"
import style0 from "./notaAutomatica.vue?vue&type=style&index=0&id=1d72b004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports